// "Menüyü Düzenle" kısa gösterimi: başlık içinde sürükle-bırak ve yıldızla favorilere ekleme
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { GripVertical, Star, LayoutDashboard, Users, ClipboardCheck, Pointer, Lock } from 'lucide-react';

const Head = ({ top, label, inline }) => (
  <p className={`${inline ? '' : 'absolute left-1'} flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wide text-slate-800`} style={inline ? undefined : { top }}>
    <span className="h-3 w-1 rounded-full bg-orange-500" />{label}
  </p>
);

const Row = ({ icon: Icon, label, top, anim, star }) => (
  <div className={`absolute left-0 right-0 flex h-9 items-center gap-2 rounded-lg border border-slate-200 bg-white px-2 text-sm ${anim}`} style={{ top }}>
    <GripVertical className="h-4 w-4 text-slate-400" />
    <Icon className="h-4 w-4 text-slate-500" />
    <span className="flex-1 text-slate-700">{label}</span>
    <span className="relative">
      <Star className="h-4 w-4 text-slate-300" />
      {star && <Star className="menu-demo-star absolute inset-0 h-4 w-4 fill-amber-400 text-amber-400" />}
    </span>
  </div>
);

const STEPS = ['1. Menüye basılı tutup kendi başlığı içinde sürükleyin', '2. Yıldıza basın', '3. Menü Favorilere çıktı!'];

export const MenuDemoDialog = ({ open, onClose }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-sm" data-testid="menu-demo-dialog">
      <DialogHeader>
        <DialogTitle>Menünüzü kişiselleştirin</DialogTitle>
        <DialogDescription>Menüleri kendi başlığı içinde sıralayın, en çok kullandıklarınızı yıldızlayıp en üste alın.</DialogDescription>
      </DialogHeader>
      <div className="mx-auto w-[260px] select-none" aria-hidden="true">
        <div className="relative h-[244px]">
          <Head top={0} label="Favoriler" />
          <div className="menu-demo-slot absolute left-0 right-0 top-[18px] h-9 rounded-lg border border-dashed border-slate-300" />
          <Head top={64} label="Genel" />
          <Row icon={LayoutDashboard} label="Dashboard" top={84} anim="menu-demo-shift" />
          <Row icon={Users} label="Personel" top={124} anim="menu-demo-shift" />
          <Row icon={ClipboardCheck} label="Çalışma İzinleri" top={164} anim="menu-demo-move z-10" star />
          <div className="absolute left-0 right-0 top-[212px] flex items-center justify-between border-t border-slate-200 pt-2">
            <Head label="Ayarlar" inline />
            <span className="flex items-center gap-1 text-[10px] text-slate-400"><Lock className="h-3 w-3" />başlıklar arası taşınmaz</span>
          </div>
          <Pointer className="menu-demo-hand pointer-events-none absolute left-0 top-0 z-20 h-6 w-6 fill-white text-slate-800" />
        </div>
        <div className="relative mt-3 h-9 text-center text-xs font-medium text-orange-600">
          {STEPS.map((s, i) => <span key={s} className={`menu-demo-step-${i} absolute inset-0`}>{s}</span>)}
        </div>
      </div>
      <Button onClick={onClose} className="w-full bg-slate-900 hover:bg-slate-800" data-testid="menu-demo-close">Anladım</Button>
    </DialogContent>
  </Dialog>
);
